// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 270px;
  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 25px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1150;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.message-popup-title {
  width: 100%;
  color: var(--tg-theme-button-color); /* Синий цвет */
  font-size: 22px;
  text-align: left;
}

.message-popup-text {
  width: 100%;
  color: var(--tg-theme-text-color); 
  padding: 10px;
  text-align: left;
  display: inline-block;
}


.message-popup-button-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 0px;
  flex-direction: row; /* Явно указываем направление в ряд */
  flex-wrap: nowrap; /* Предотвращаем перенос на новую строку */
  gap: 10px;
}

.message-popup-button-container.vertical {
  flex-direction: column; 
  gap: 6px;
  margin-bottom: 3px;

}

.message-popup-button {
  min-width: 40%;
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  font-size: 15px;
  border: none;
  padding: 10px 12px;
  border-radius: 10px;
  /* margin-left: 8px; */
  cursor: pointer;
  flex-shrink: 0; /* Предотвращаем сжатие кнопок */
}

.message-popup-button.cancel-button {
  background-color: var(--tg-theme-hint-color);
}
.message-popup-button.destructive-button {
  background-color: var(--tg-theme-destructive-text-color);
}

.message-popup-button.wide {
  width: 100%;
}

.message-popup-settings-label {
  width: 100%;
  display: flex;
  align-items: center;  /* Выравнивание по вертикали */
  justify-content: left; /* Выравнивание по горизонтали */
  cursor: pointer;
  font-size: 14px;
  color: var(--tg-theme-text-color);
}
.message-popup-settings-text {
  padding-bottom: 2px;
}

.message-popup-input-field {
  width: 95%;
  font-size: 16px;
  border-radius: 12px;

  padding: 11px;
  margin: 5px;
  box-sizing: border-box;  /* Включаем рамку в размеры элемента */

  background-color: var(--tg-theme-bg-color);
  color: var(--tg-theme-text-color);
  border-color: var(--tg-theme-button-color);
  border-width: 2px;  /* Задаем толщину рамки */
  border-style: solid;  /* Убедимся, что стиль рамки задан */
}

.message-popup-input-field:focus {
  outline: none; /* Убираем стандартную обводку браузера */
  border-color: #00BB00; /* Зеленый цвет рамки при фокусе */
}


a.message-popup-button {
  box-sizing: border-box;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/menus/popup/PopupMessage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mCAAmC,EAAE,eAAe;EACpD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB,EAAE,qCAAqC;EAC1D,iBAAiB,EAAE,0CAA0C;EAC7D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;;AAEpB;;AAEA;EACE,cAAc;EACd,8CAA8C;EAC9C,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,4CAA4C;AAC9C;AACA;EACE,wDAAwD;AAC1D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB,GAAG,8BAA8B;EACpD,qBAAqB,EAAE,gCAAgC;EACvD,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;;EAEnB,aAAa;EACb,WAAW;EACX,sBAAsB,GAAG,sCAAsC;;EAE/D,0CAA0C;EAC1C,iCAAiC;EACjC,0CAA0C;EAC1C,iBAAiB,GAAG,yBAAyB;EAC7C,mBAAmB,GAAG,oCAAoC;AAC5D;;AAEA;EACE,aAAa,EAAE,yCAAyC;EACxD,qBAAqB,EAAE,kCAAkC;AAC3D;;;AAGA;EACE,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".message-popup {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 270px;\r\n  text-align: center;\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 25px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 12px;\r\n  z-index: 1150;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.message-popup-title {\r\n  width: 100%;\r\n  color: var(--tg-theme-button-color); /* Синий цвет */\r\n  font-size: 22px;\r\n  text-align: left;\r\n}\r\n\r\n.message-popup-text {\r\n  width: 100%;\r\n  color: var(--tg-theme-text-color); \r\n  padding: 10px;\r\n  text-align: left;\r\n  display: inline-block;\r\n}\r\n\r\n\r\n.message-popup-button-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  width: 100%;\r\n  margin-top: 5px;\r\n  margin-bottom: 0px;\r\n  flex-direction: row; /* Явно указываем направление в ряд */\r\n  flex-wrap: nowrap; /* Предотвращаем перенос на новую строку */\r\n  gap: 10px;\r\n}\r\n\r\n.message-popup-button-container.vertical {\r\n  flex-direction: column; \r\n  gap: 6px;\r\n  margin-bottom: 3px;\r\n\r\n}\r\n\r\n.message-popup-button {\r\n  min-width: 40%;\r\n  background-color: var(--tg-theme-button-color);\r\n  color: var(--tg-theme-button-text-color);\r\n  font-size: 15px;\r\n  border: none;\r\n  padding: 10px 12px;\r\n  border-radius: 10px;\r\n  /* margin-left: 8px; */\r\n  cursor: pointer;\r\n  flex-shrink: 0; /* Предотвращаем сжатие кнопок */\r\n}\r\n\r\n.message-popup-button.cancel-button {\r\n  background-color: var(--tg-theme-hint-color);\r\n}\r\n.message-popup-button.destructive-button {\r\n  background-color: var(--tg-theme-destructive-text-color);\r\n}\r\n\r\n.message-popup-button.wide {\r\n  width: 100%;\r\n}\r\n\r\n.message-popup-settings-label {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;  /* Выравнивание по вертикали */\r\n  justify-content: left; /* Выравнивание по горизонтали */\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: var(--tg-theme-text-color);\r\n}\r\n.message-popup-settings-text {\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.message-popup-input-field {\r\n  width: 95%;\r\n  font-size: 16px;\r\n  border-radius: 12px;\r\n\r\n  padding: 11px;\r\n  margin: 5px;\r\n  box-sizing: border-box;  /* Включаем рамку в размеры элемента */\r\n\r\n  background-color: var(--tg-theme-bg-color);\r\n  color: var(--tg-theme-text-color);\r\n  border-color: var(--tg-theme-button-color);\r\n  border-width: 2px;  /* Задаем толщину рамки */\r\n  border-style: solid;  /* Убедимся, что стиль рамки задан */\r\n}\r\n\r\n.message-popup-input-field:focus {\r\n  outline: none; /* Убираем стандартную обводку браузера */\r\n  border-color: #00BB00; /* Зеленый цвет рамки при фокусе */\r\n}\r\n\r\n\r\na.message-popup-button {\r\n  box-sizing: border-box;\r\n  text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
